import { Footer, Header } from "@/components/shared";
import { updatePageSEO } from "@/utils/seo";
import { useEffect } from "react";

const AboutUs = () => {
  useEffect(() => {
    updatePageSEO("/about-us");
  }, []);

  return (
    <div className="min-h-screen bg-black text-white">
      <Header />

      <div className="max-w-2xl mx-auto px-6 pt-40 pb-32">
        <p
          className="text-xs tracking-widest uppercase mb-6"
          style={{ opacity: 0.4 }}
        >
          The Content Group Limited
        </p>
        <h1
          className="font-black uppercase mb-12 leading-none"
          style={{
            fontFamily: "'Bricolage Grotesque', sans-serif",
            fontSize: "clamp(2.5rem, 7vw, 4.5rem)",
            letterSpacing: "-0.03em",
          }}
        >
          About Us
        </h1>

        <div className="space-y-8 text-gray-400 leading-relaxed">
          <p className="text-white text-lg leading-relaxed">
            With over 25 years of experience, Daisy &amp; Alex Hill have worked
            in the property industry for big names like CBRE, The Collective and
            Allied London, as well as their own marketing studio, formally Yolk
            Studios - working with global brands like Ace &amp; Tate, Bumble,
            Pan Macmillan and creating destinations like Barking Riverside &amp;
            20 Fenchurch Street.
          </p>

          <p>
            Over the years, we've watched the landscape shift. The old agency
            model - where you're left guessing what's on offer, how to engage,
            or what it'll cost - just doesn't cut it anymore. We've been on both
            sides of the table, and frankly, we've had enough of the smoke and
            mirrors. Too many times, we've seen great ideas lost in process, or
            worse, paid for and never delivered.
          </p>

          <p>
            So, we're doing things differently. Our approach is simple: what you
            see is what you get. You'll know exactly what we do, what it costs,
            and what to expect - right from the start. No hidden fees, no vague
            promises, no "kiss me quick" agency fluff. Just execution, delivery,
            and a clear plan of action.
          </p>

          <p>
            Through our Culture Transformation Lab, we've put our ideas and
            strategy front and centre. For every asset, we share data, insights,
            and trends as we go - keeping you in the loop and your brand
            relevant to what's happening now. Transforming spaces into true
            cultural assets takes time, energy, and relentless focus on your
            community. That's our promise.
          </p>
        </div>

        <div className="border-t border-white/10 mt-20 pt-20 space-y-12">
          {[
            {
              title: "Authentic Connection",
              body: "Consumers want new and fresh experiences to make them feel good and provide a great story for tomorrow. Never underestimate the power of quality and joy.",
            },
            {
              title: "Long-term Brand Building",
              body: "Places and brands need a variety of compelling content to create and maintain brand relevance and buzz. People value consistency, authenticity and face-to-face connection.",
            },
            {
              title: "Supporting Local Economy",
              body: "Independent creatives need platforms to showcase their craft and innovative mediums to market themselves and their work. Purposeful partnerships are good for business and for the prosperity of the UK's Creative Industries.",
            },
          ].map((item) => (
            <div key={item.title} className="border-t border-white/10 pt-8">
              <h3
                className="font-bold uppercase text-sm tracking-wide mb-3"
                style={{ fontFamily: "'Bricolage Grotesque', sans-serif" }}
              >
                {item.title}
              </h3>
              <p className="text-gray-500 leading-relaxed text-sm">{item.body}</p>
            </div>
          ))}
        </div>

        <div className="mt-20 pt-12 border-t border-white/10">
          <a
            href="mailto:hello@thecontentgroup.co"
            className="text-sm tracking-widest uppercase border border-white/30 hover:border-white px-8 py-4 rounded-full transition-colors inline-block"
            style={{ fontFamily: "'Bricolage Grotesque', sans-serif" }}
          >
            Get in touch
          </a>
        </div>
      </div>

      <Footer variant="dark" />
    </div>
  );
};

export default AboutUs;
